import { render, staticRenderFns } from "./GraduatesSinglePlacementsListItem.vue?vue&type=template&id=143bc0c2&"
import script from "./GraduatesSinglePlacementsListItem.vue?vue&type=script&lang=js&"
export * from "./GraduatesSinglePlacementsListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports